export default __webpack_public_path__ + "locales/cs/SmartBanner.json?hash=5998853c47b2de92be4583cc171e0f63";